import { render, staticRenderFns } from "./PerformanceReviewDiscussionItem.vue?vue&type=template&id=1fc126dd&scoped=true&"
import script from "./PerformanceReviewDiscussionItem.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewDiscussionItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewDiscussionItem.vue?vue&type=style&index=0&id=1fc126dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc126dd",
  null
  
)

export default component.exports